export default __webpack_public_path__ + "static/logo-fd9049c4d2fd73d7b1b504d3a9adb00c.png";